import TransactionCheckoutHeader from "../components/TransactionCheckoutHeader";
import ModalBackButton from "../components/ModalBackButton";
import { LogoWithBadge } from "../components/LogoWithBadge";
import PrimaryButton from "../components/PrimaryButton";

import { formatDisplayAmount } from "../lib/formatDisplayAmount";

type Props = {
  onBack: () => void;
  gasRefuelAmount: string;
  gasRefuelUSD: string;
  chainLogoUrl: string;
  chainName: string;
  gasCurrencySymbol: string;
  gasCurrencyLogoUrl: string;
};

export function GasRefillExplainer({
  onBack,
  gasRefuelAmount,
  gasRefuelUSD,
  chainLogoUrl,
  chainName,
  gasCurrencySymbol,
  gasCurrencyLogoUrl,
}: Props) {
  return (
    <>
      <ModalBackButton onClick={onBack} />
      <div>
        <TransactionCheckoutHeader title="Gas refill" />

        <div className="mt-4 flex flex-col">
          <div className="flex items-center space-x-3">
            {chainLogoUrl && (
              <LogoWithBadge
                badgeUrl={chainLogoUrl}
                logoUrl={gasCurrencyLogoUrl}
                size="lg"
              />
            )}
            <div>
              <h2 className="font-medium text-lg text-[--color-text-primary]">
                {formatDisplayAmount(gasRefuelAmount)} {gasCurrencySymbol}
              </h2>
              {gasRefuelUSD && (
                <p className="text-sm text-[--color-text-secondary]">
                  $
                  {Number(gasRefuelUSD).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              )}
            </div>
          </div>

          <div className="mt-6 bg-[--color-background-secondary] p-4 rounded-lg">
            <h3 className="font-medium text-base mb-2 text-[--color-text-primary]">
              What is Gas Refill?
            </h3>
            <p className="text-sm text-[--color-text-secondary] mb-3">
              You need to have {gasCurrencySymbol} in your wallet to make
              transactions on {chainName} .
            </p>
            <p className="text-sm text-[--color-text-secondary]">
              {formatDisplayAmount(gasRefuelAmount)} {gasCurrencySymbol} will be
              deposited to your wallet so you will be able to make transactions
              on {chainName}.
            </p>
          </div>

          <PrimaryButton className="mt-4" onClick={onBack}>
            Got it
          </PrimaryButton>
        </div>
      </div>
    </>
  );
}
